export default __webpack_public_path__ + "static/media/Glossary.Icon.b4bbd0d5.svg";